// extracted by mini-css-extract-plugin
module.exports = {"headerBar":"Na-z","pointsSection":"Oa-z","goToDashboard":"Pa-z"};